export enum ProfileSettingsKey {
  User = 'user',
  Social = 'social',
  Employment = 'employment',
  Education = 'education',
}
